import React, { FC, useRef, useEffect, useState } from 'react';

import Model from './model';

import { TargetMarker, StationMarker } from 'views/components/map-markers';
import { Map, Nonakass, NagataStation, TokuanStation } from './index.styled';

interface Props {
  watch?: () => void;
}

const GoogleMap: FC<Props> = props => {

  const { watch } = props;
  const map = useRef<HTMLDivElement>(null);
  const nonakass = useRef<HTMLDivElement>(null);
  const nagataStation = useRef<HTMLDivElement>(null);
  const tokuanStation = useRef<HTMLDivElement>(null);
  const model = useRef<Model>();
  const [ready, setReady] = useState(false);

  function checkGoogleMaps(): boolean {
    return typeof google !== 'undefined' && typeof google.maps !== 'undefined';
  }

  function loadGoogleMaps() {
    if (checkGoogleMaps()) return;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GCP_API_KEY}&region=JP&language=ja`;
    script.async = true;
    script.defer = true;
    script.onload = () => watchGoogleMaps();
    document.body.appendChild(script);
  }

  function watchGoogleMaps() {
    init();
  }

  function checkRefs(): boolean {
    return !!(map.current && nonakass.current && nagataStation.current && tokuanStation.current);
  }

  function watchRefs() {
    init();
  }

  function init() {
    if (!checkGoogleMaps() || !checkRefs()) return;
    model.current = new Model({ map: map.current!, nonakass: nonakass.current!, nagataStation: nagataStation.current!, tokuanStation: tokuanStation.current! });
    model.current.watch().then(() => {
      setReady(true);
      if (watch) watch();
    });
  }

  useEffect(loadGoogleMaps, []);
  useEffect(watchRefs, [map, nonakass, nagataStation, tokuanStation]);

  return (
    <Map ref={map}>
      <Nonakass ref={nonakass} ready={ready}>
        <a href="https://goo.gl/maps/CPqEX239gFjDzmvR7" target="_blank">
          <TargetMarker />
        </a>
      </Nonakass>
      <NagataStation ref={nagataStation} ready={ready}>
        <a href="https://goo.gl/maps/3dompebDquaVSfQS7" target="_blank">
          <StationMarker />
        </a>
      </NagataStation>
      <TokuanStation ref={tokuanStation} ready={ready}>
        <a href="https://goo.gl/maps/mWreCcN9pw2GoJHF7" target="_blank">
          <StationMarker />
        </a>
      </TokuanStation>
    </Map>
  );
};

export default GoogleMap;
